module.exports = __webpack_public_path__ + "static/media/cf.2171101e.svg";